module.exports = __webpack_public_path__ + "img/cross sell Up Dejun.77847ceb.jpeg";